import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TLatLng } from "../../types/map";
import { GoogleGeocodeResponse, GoogleSnapToRoadResponse } from "../types/Map";
import { API_METHODS } from "./constants";
import { GOOGLEMAPS_ENDPOINTS } from "./endpoints";
import { handleAuthErrorCode } from "./errorCodes";

export enum MapApiTags {
  AUTOSUGGEST = "AUTOSUGGEST",
}

export const MapAPIs = createApi({
  reducerPath: "mapAPI",
  tagTypes: [MapApiTags.AUTOSUGGEST],
  baseQuery: fetchBaseQuery({
    // baseUrl: API_SERVER_URL,
    prepareHeaders: async (headers) => headers,
  }),
  endpoints: (builder) => ({
    // autosuggest
    // autosuggestAddress: builder.query<BingAutosuggestResponse, string>({
    //   query: (query: string) => {
    //     return {
    //       url: BINGMAPS_ENDPOINTS.AUTOSUGGEST(query),
    //       method: API_METHODS.GET,
    //     };
    //   },
    //   transformErrorResponse(baseQueryReturnValue) {
    //     handleAuthErrorCode(baseQueryReturnValue);
    //     return baseQueryReturnValue;
    //   },
    //   transformResponse: (response: BingAutosuggestResponse) => {
    //     return response;
    //   },
    // }),

    // geocode
    // geocode: builder.query<BingGeocodeResponse, BingLocationAddress>({
    //   query: (address: BingLocationAddress) => {
    //     return {
    //       url: BINGMAPS_ENDPOINTS.GEOCODE(address),
    //       method: API_METHODS.GET,
    //     };
    //   },
    //   transformErrorResponse(baseQueryReturnValue) {
    //     handleAuthErrorCode(baseQueryReturnValue);
    //     return baseQueryReturnValue;
    //   },
    //   transformResponse: (response: BingGeocodeResponse) => {
    //     return response;
    //   },
    // }),

    // reverse geocode
    // reverseGeocode: builder.query<BingReverseGeocodeResponse, TLatLng>({
    //   query: (latLng: TLatLng) => {
    //     return {
    //       url: BINGMAPS_ENDPOINTS.REVERSE_GEOCODE(latLng),
    //       method: API_METHODS.GET,
    //     };
    //   },
    //   keepUnusedDataFor: 6 * 60 * 60 * 1000, // 6 hours
    //   transformErrorResponse(baseQueryReturnValue) {
    //     handleAuthErrorCode(baseQueryReturnValue);
    //     return baseQueryReturnValue;
    //   },
    //   transformResponse: (response: BingReverseGeocodeResponse) => {
    //     return response;
    //   },
    // }),

    // imagery meta - bing
    // imageryMeta: builder.query<BingImageryMetaResponse, BingImageryMetaRequest>(
    //   {
    //     query: (params: BingImageryMetaRequest) => {
    //       return {
    //         url: BINGMAPS_ENDPOINTS.IMAGERY_META(params),
    //         method: API_METHODS.GET,
    //       };
    //     },
    //     transformErrorResponse(baseQueryReturnValue) {
    //       handleAuthErrorCode(baseQueryReturnValue);
    //       return baseQueryReturnValue;
    //     },
    //     transformResponse: (response: BingImageryMetaResponse) => {
    //       return response;
    //     },
    //   }
    // ),

    // imagery meta - google
    gImageryMeta: builder.query<any, google.maps.LatLngLiteral>({
      query: ({ lat, lng }: google.maps.LatLngLiteral) => {
        return {
          url: GOOGLEMAPS_ENDPOINTS.IMAGERY_META(lat, lng),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: any) => {
        return response;
      },
    }),

    // google auto suggest address
    gAutosuggestAddress: builder.query<
      google.maps.places.AutocompletePrediction[],
      string
    >({
      query: (query: string) => {
        return {
          url: GOOGLEMAPS_ENDPOINTS.AUTOSUGGEST(query),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: any) => {
        return response.predictions;
      },
    }),

    // google maps streetview metadata
    gStreetviewMeta: builder.query<any, google.maps.LatLngLiteral>({
      query: ({ lat, lng }: google.maps.LatLngLiteral) => {
        return {
          url: GOOGLEMAPS_ENDPOINTS.STREETVIEW_META(lat, lng),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: any) => {
        return response;
      },
    }),

    // google maps - snap to road
    gSnapToRoad: builder.query<
      GoogleSnapToRoadResponse,
      { points: google.maps.LatLngLiteral[]; interpolate: boolean }
    >({
      query: ({
        points,
        interpolate,
      }: {
        points: google.maps.LatLngLiteral[];
        interpolate: boolean;
      }) => {
        return {
          url: GOOGLEMAPS_ENDPOINTS.SNAP_TO_ROAD(points, interpolate),
          method: API_METHODS.GET,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: GoogleSnapToRoadResponse) => {
        return response;
      },
    }),
    // reverse geocode
    gReverseGeocode: builder.query<GoogleGeocodeResponse, TLatLng>({
      query: (latLng: TLatLng) => {
        return {
          url: GOOGLEMAPS_ENDPOINTS.REVERSE_GEOCODE(latLng),
          method: API_METHODS.GET,
        };
      },
      keepUnusedDataFor: 6 * 60 * 60 * 1000, // 6 hours
      transformErrorResponse(baseQueryReturnValue) {
        handleAuthErrorCode(baseQueryReturnValue);
        return baseQueryReturnValue;
      },
      transformResponse: (response: GoogleGeocodeResponse) => {
        return response;
      },
    }),
  }),
});

export const {
  // useLazyAutosuggestAddressQuery,
  // useLazyGeocodeQuery,
  // useReverseGeocodeQuery,
  // useLazyReverseGeocodeQuery,
  // useLazyImageryMetaQuery,
  useLazyGImageryMetaQuery,
  useLazyGAutosuggestAddressQuery,
  useLazyGStreetviewMetaQuery,
  useLazyGSnapToRoadQuery,
  useLazyGReverseGeocodeQuery,
  useGReverseGeocodeQuery,
} = MapAPIs;
